import { Platform } from 'react-native';
import * as Application from 'expo-application';

/** A stable-ish, hardware-backed device identifier (resets on Android
 * factory reset / iOS app reinstall — not forgeable per-request the way a
 * client-supplied string is) — used server-side as a weak signal against
 * one person farming referral rewards or self-approving via a second
 * account on the same phone. Undefined on web, where no such identifier
 * exists; the backend treats an absent fingerprint as simply not a signal. */
export async function getDeviceFingerprint(): Promise<string | undefined> {
  try {
    if (Platform.OS === 'android') {
      return Application.getAndroidId() ?? undefined;
    }
    if (Platform.OS === 'ios') {
      return (await Application.getIosIdForVendorAsync()) ?? undefined;
    }
  } catch {
    // Best-effort signal — never block registration over it.
  }
  return undefined;
}
